import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

import { getUser } from '../../User/actions';
import { setSection } from '../../Dictionaries/actions';
import getDictionary from '../../../utils/dictionaries';
import { capitalizeFirstLetter, textToParagraphs } from '../../../utils/formater';
import connectDataFetchers from '../../../lib/connectDataFetchers';
import Announcement from '../../../classes/announcement/announcement';
import attributeFactory from '../../../classes/announcement/attributes/attributeFactory';
import { Price as FinancePrice } from '../../../classes/finance/index';

import { PriceSubscriptionButton } from '../../../ui/Controls/Subscriptions';
import ScrollToTopOnMount from '../../../ui/Common/ScrollToTopOnMount';
import { AnnouncementCardSlider } from '../../../ui/Sliders';

import Breadcrumbs from '../../../ui/Breadcrumbs';
import PriceHistoryPopup from '../../../ui/Price/PriceHistoryPopup';
import { CardAnnouncement as Placeholder } from '../../../ui/Placeholders';
import { SectionPanel, SectionHeader } from '../../../ui/Section';
import AttributeList from '../../../ui/Views/AttributeList';

import { fetchAnnouncement } from '../actions';

class Card extends Component {
  constructor (props) {
    super(props);

    this.state = {};

    this.dealType = props.dealType;
    this.realtyType = props.realtyType;
    this.seoTitle = props.defaultSeoTitle;
    this.seoDescription = props.defaultSeoDescription;
    this.domain = props.domain;

    this.item = props.announcementItem ? new Announcement(props.announcementItem, props.dictionary) : null;
    this.store = this.item ? attributeFactory(this.item) : null;

    this.renderHeader = this.renderHeader.bind(this);
    this.renderCard = this.renderCard.bind(this);
  }

  componentWillReceiveProps (nextProps, nextContext) {
    if (nextProps.announcementItem && !nextProps.announcementItem.equals(this.props.announcementItem)) {
      this.item = new Announcement(nextProps.announcementItem, this.props.dictionary);
      this.store = this.item ? attributeFactory(this.item) : null;
    }
  }

  componentDidUpdate (prevProps, prevState, prevContext) {
    ReactTooltip.rebuild();
  }

  renderLoading () {
    return <div style={{position: 'relative'}}>
      <Placeholder />

      <div className='ajax-waiting-overlay'>
        <div className='radial-progress'>
          <div className='circle'>
            <div className='fill' />
          </div>
        </div>
      </div>
    </div>;
  }

  renderSeo () {
    const {meta} = this.props;
    const title = meta && meta.get('seoTitle');
    const description = meta && meta.get('seoDescription');

    return (
      <Helmet
        htmlAttributes={{ lang: 'ru' }}
        title={title || this.seoTitle}
        meta={[
          {
            'name': 'description',
            'content': description || this.seoDescription
          }
        ]}
      />
    );
  }

  /**
   * Жилой комплекс, Коттеджный поселок, Гаражный кооператив, Садоводческое товарищество
   * @returns {Array}
   */
  renderComplex () {
    const item = this.item;
    const complexes = [
      item.getResidentialComplex(),
      item.getCottageComplex(),
      item.getGardenAssociation(),
      item.getGarageComplex()
    ];

    return complexes
        .filter(x => x)
        .map((complex, index) => {
          return complex.getUri() ? (
            <a key={index} className='residential link-base' href={complex.getUri()} title={complex.getType()} target='_blank'>
              {complex.getLabel()}
            </a>
          ) : (
            <span key={index} className='residential'>{complex.getLabel()}</span>
          );
        });
  }

  getTitle () {
    const property = this.item.getProperty();
    const building = property.getBuilding();

    const type = property.getType();
    const totalArea = property.getRoom().getTotalArea();
    const geolocation = property.getGeoLocation();

    const title = [
      type ? capitalizeFirstLetter(type.get('fullName')) : null,
      totalArea ? totalArea.getLabel(false) : null
    ];

    return (
      <div>
        <h1 itemProp='name' className='announcement-card-title'>
          { title.filter(Boolean).join(', ')}
          { geolocation && <span><br />{geolocation.getShortAddress()}</span> }
        </h1>

        <div className='announcement-card-sub-title'>
          { building.getLabelNewBuilding() && <span>{building.getLabelNewBuilding(true)}.&nbsp;</span>}
          { this.renderComplex() }
        </div>
      </div>
    );
  };

  getPrice () {
    // TODO onClick={yt('new_card_tracking_price_top')}
    const item = this.item;
    const priceInfo = FinancePrice.getPriceInfo(item);
    const priceHistory = item.getPriceHistory();

    return (
      <div className='announcement-card-price' itemProp='offers' itemScope itemType='http://schema.org/Offer'>
        <meta itemProp='price' content={item.getPrice().getValue()} />
        <meta itemProp='priceCurrency' content='RUB' />

        <div className='flex flex-items-center flex-between'>
          <PriceHistoryPopup
            history={priceHistory}
            dealType={item.getDealType()}
            realtyType={item.getRealtyType()}
            realtyId={item.getProperty().getId()}
          >
            <span className='main-param'>
              {priceInfo.pricePer}
            </span>
          </PriceHistoryPopup>

          <PriceSubscriptionButton
            isIconBtn
            dealType={this.props.dealType}
            realtyType={this.props.realtyType}
            realtyId={item.getId()} />
        </div>

        { priceInfo.addition && (<div className='deal-condition'>{priceInfo.addition}</div>) }
      </div>
    );
  }

  renderHeader () {
    // TODO yt("new_card_breadcrumb")
    return (
      <div className='announcement-card-header'>
        <div className='container'>
          <div className='container-header'>
            <Breadcrumbs items={this.item.getBreadcrumbs()} onClickItem={() => console.log('yt("new_card_breadcrumb")')} />

            <div className='flex flex-items-stretch flex-between'>
              {this.getTitle()}
              {this.getPrice()}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderAdminControlls () {
    return (
      <SectionPanel>
        Удалить/Изменить/ЛК/Сброить координаты
      </SectionPanel>
    );
  }

  renderAttributes (attributes) {
    return (
      <SectionPanel key={attributes.title}>
        <SectionHeader>{attributes.title}</SectionHeader>
        <AttributeList attributeList={attributes.items} />
      </SectionPanel>
    );
  }

  renderDescription () {
    return (
      <SectionPanel>
        <SectionHeader>Описание</SectionHeader>
        { textToParagraphs(this.item.getDescription())}
      </SectionPanel>
    );
  }

  renderMap () {
    return (
      <SectionPanel>
        <SectionHeader>Карта</SectionHeader>

      </SectionPanel>
    );
  }

  renderMicroDistrictRating () {
    return (
      <SectionPanel>
        <SectionHeader>Рейтинг микрорайона</SectionHeader>

      </SectionPanel>
    );
  }

  renderResidentialComplexRating () {
    return (
      <SectionPanel>
        <SectionHeader>Рейтинг жилого комплекса</SectionHeader>

      </SectionPanel>
    );
  }

  renderPriceHistory () {
    return (
      <SectionPanel>
        <SectionHeader>История изменения цены</SectionHeader>

      </SectionPanel>
    );
  }

  renderPriceDinamic () {
    return (
      <SectionPanel>
        <SectionHeader>Динамика цен</SectionHeader>

      </SectionPanel>
    );
  }

  renderContactForm () {
    return (
      <SectionPanel>
        <SectionHeader>Контактная форма</SectionHeader>

      </SectionPanel>
    );
  }

  renderSimilarFilters () {
    return (
      <SectionPanel>
        <SectionHeader>Найти похожие варианты</SectionHeader>

      </SectionPanel>
    );
  }

  renderCard () {
    if (!this.item) {
      return null;
    }

    return (
      <div>
        <AnnouncementCardSlider photos={this.item.getPhotos()} photoSize='320x240' />

        { this.renderHeader() }

        <div className='card-content flex flex-between'>
          <div className='card-body'>
            <br />
            { this.renderAdminControlls() }

            { this.store && this.store.getAttributes().map(store => this.renderAttributes(store)) }

            { this.renderDescription() }
            { this.renderMap() }
            { this.renderMicroDistrictRating() }
            { this.renderResidentialComplexRating() }
            { this.renderPriceHistory() }
            { this.renderPriceDinamic() }
            { this.renderContactForm() }
            { this.renderSimilarFilters() }
          </div>

          <div className='card-aside'>
            Боковая панель
          </div>
        </div>

      </div>
    );
  }

  render () {
    const { announcementLoading } = this.props;

    return (
      <div className='announcement-card-page' itemScope itemType='http://schema.org/Product'>
        { this.renderSeo() }

        <ScrollToTopOnMount />

        { announcementLoading ? this.renderLoading() : this.renderCard() }

      </div>
    );
  }
}

Card.propTypes = {
  domain: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,

  dealType: PropTypes.string.isRequired,
  realtyType: PropTypes.string.isRequired,
  defaultSeoTitle: PropTypes.string,
  defaultSeoDescription: PropTypes.string,

  dictionary: PropTypes.object.isRequired,
  announcementItem: PropTypes.object,
  announcementLoading: PropTypes.bool,
  announcementLoaded: PropTypes.bool,
  meta: PropTypes.object
};

Card.defaultProps = {
  announcementItem: null,
  defaultSeoTitle: 'Поиск объявлений',
  defaultSeoDescription: 'Поиск объявлений',
  announcementLoading: true,
  meta: {}
};

function mapStateToProps (state) {
  const announcement = state.get('announcement');

  return {
    domain: state.get('domain'),
    user: state.get('user'),
    meta: announcement.get('meta'),
    announcementItem: announcement.get('announcementItem'),
    announcementLoading: !!announcement.get('loading'),
    announcementLoaded: !!announcement.get('loaded'),
    dictionary: getDictionary(state.get('dictionaries'))
  };
}

function mapDispatchToProps (dispatch) {
  const actions = bindActionCreators({
    getUser,
    setSection,
    fetchAnnouncement
  }, dispatch);

  actions.dispatch = dispatch;
  return actions;
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(
    connectDataFetchers(Card, [ getUser, fetchAnnouncement ])
));



// WEBPACK FOOTER //
// ./src/app/CardAnnouncement/components/Card.js